import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api`;

// Create axios instance with default config
const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Booking Service
export const bookingService = {
  create: async (bookingData) => {
    try {
      const response = await apiClient.post('/bookings', bookingData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
  
  getAll: async () => {
    try {
      const response = await apiClient.get('/bookings');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
  
  getById: async (bookingId) => {
    try {
      const response = await apiClient.get(`/bookings/${bookingId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
  
  updateStatus: async (bookingId, status) => {
    try {
      const response = await apiClient.patch(`/bookings/${bookingId}/status`, { status });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
  
  update: async (bookingId, bookingData) => {
    try {
      const response = await apiClient.patch(`/bookings/${bookingId}`, bookingData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }
};

// Service Service
export const serviceService = {
  getAll: async () => {
    try {
      const response = await apiClient.get('/services');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
  
  getById: async (serviceId) => {
    try {
      const response = await apiClient.get(`/services/${serviceId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
  
  create: async (serviceData) => {
    try {
      const response = await apiClient.post('/services', serviceData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
  
  update: async (serviceId, serviceData) => {
    try {
      const response = await apiClient.patch(`/services/${serviceId}`, serviceData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
  
  delete: async (serviceId) => {
    try {
      const response = await apiClient.delete(`/services/${serviceId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }
};

// Testimonial Service
export const testimonialService = {
  getAll: async () => {
    try {
      const response = await apiClient.get('/testimonials');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
  
  create: async (testimonialData) => {
    try {
      const response = await apiClient.post('/testimonials', testimonialData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }
};

// Garage Service
export const garageService = {
  getAll: async () => {
    try {
      const response = await apiClient.get('/garages');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
  
  getById: async (garageId) => {
    try {
      const response = await apiClient.get(`/garages/${garageId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
  
  create: async (garageData) => {
    try {
      const response = await apiClient.post('/garages', garageData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
  
  update: async (garageId, garageData) => {
    try {
      const response = await apiClient.patch(`/garages/${garageId}`, garageData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
  
  delete: async (garageId) => {
    try {
      const response = await apiClient.delete(`/garages/${garageId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
  
  toggleStatus: async (garageId) => {
    try {
      const response = await apiClient.patch(`/garages/${garageId}/toggle-status`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
  
  assignToBooking: async (bookingId, garageId) => {
    try {
      const response = await apiClient.patch(`/bookings/${bookingId}/assign-garage?garage_id=${garageId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }
};

// Order Service
export const orderService = {
  getAll: async () => {
    try {
      const response = await apiClient.get('/orders');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
  
  getById: async (orderId) => {
    try {
      const response = await apiClient.get(`/orders/${orderId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
  
  createFromBooking: async (bookingId) => {
    try {
      const response = await apiClient.post('/orders', { booking_id: bookingId });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
  
  updateStage: async (orderId, stage, notes) => {
    try {
      const response = await apiClient.patch(`/orders/${orderId}/stage`, { stage, notes });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
  
  addImage: async (orderId, imageUrl, caption) => {
    try {
      const response = await apiClient.post(`/orders/${orderId}/images`, { image_url: imageUrl, caption });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
  
  updateNotes: async (orderId, notes) => {
    try {
      const response = await apiClient.patch(`/orders/${orderId}/notes`, { notes });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }
};

// Notes Service
export const notesService = {
  getByBooking: async (bookingId) => {
    try {
      const response = await apiClient.get(`/bookings/${bookingId}/notes`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
  
  create: async (bookingId, author, content) => {
    try {
      const response = await apiClient.post(`/bookings/${bookingId}/notes`, { author, content });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }
};

// Email Service
export const emailService = {
  getByBooking: async (bookingId) => {
    try {
      const response = await apiClient.get(`/bookings/${bookingId}/emails`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
  
  send: async (bookingId, emailData) => {
    try {
      const response = await apiClient.post(`/bookings/${bookingId}/emails`, emailData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }
};

// Chatbot Service
export const chatbotService = {
  sendMessage: async (messageData) => {
    try {
      const response = await apiClient.post('/chatbot/message', messageData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  getConversation: async (sessionId) => {
    try {
      const response = await apiClient.get(`/chatbot/conversation/session/${sessionId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  getAllConversations: async () => {
    try {
      const response = await apiClient.get('/chatbot/conversations');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }
};


export default apiClient;
